import { Col, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { PageTitle } from 'shared/components/Fonts';
import { ButtonPlaceholder, TextPlaceholder } from 'shared/placeholders';

export const UserDetailPageSkeleton = () => (
  <>
    <Row className="mb-3">
      <Col>
        <PageTitle>Información del Usuario</PageTitle>
      </Col>
      <Col>
        <ButtonPlaceholder className="float-end">Editar</ButtonPlaceholder>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col>
        <Card>
          <Card.Title>Datos del usuario</Card.Title>
          <Card.Body $padding>
            <Row className="mb-2">
              <Col>
                <TextPlaceholder />
                <TextPlaceholder />
              </Col>
              <Col>
                <TextPlaceholder />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <TextPlaceholder />
                <TextPlaceholder />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>

    <Row className="mb-3">
      <Col>
        <Card>
          <Card.Title>Información que puede consultar</Card.Title>
          <Card.Body $padding>
            <Row className="mb-2">
              <Col>
                <TextPlaceholder />
                <TextPlaceholder />
              </Col>
              <Col>
                <TextPlaceholder />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <TextPlaceholder />
                <TextPlaceholder />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>

    <Row className="mb-3">
      <Col>
        <Card>
          <Card.Title>Funcionalidades</Card.Title>
          <Card.Body $padding>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </>
);
